import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取支付类型列表 **/
    GET_PAYMENT_LIST(data) {
        controller='EsPayment';
        action='GetPaymentList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },
   
    /** 获取支付详情 **/
    GET_PAYMENT_DETAIL(data) {
        controller='EsPayment';
        action='GetPaymentDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改支付上下架信息 **/
    UPDATE_SHOW(data) {
        controller='EsPayment';
        action='UpdateShow';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}